import { displayQrCode } from "../../Utils/utils";
import { TutorTestManager } from "./TutorTestManager";

const AbQrCode = class AbQrCode{
    wrapper:JQuery;

    constructor(wrapper) {
        this.wrapper = $(wrapper);
        this.addListeners();
    }

    addListeners(){
        this.wrapper.on("click", ".display-qr-code", function(){
            const code = $(this).parent().attr('data-code');
            displayQrCode(code);
        })
    }
}

export function loadTests(){
    const qrcode = new AbQrCode("#as-hub-tab");

    const TutorAbManagement = new TutorTestManager();
}
